<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    中大站<br>
站点介绍<br>
中大站为6号线支线以光明站为起点的第3座车站，位于公常路和荔美北街交叉口，沿公常路东西向跨路口布置。中大站为地下二层岛式车站，地面二层为站台层，地面一层为站厅层。车站北侧有中山大学（深圳校区），东侧主要有大新新美工业园，南侧主要有万代恒高新科技园、丽枫酒店、荔山公园，西侧主要有硅谷高科工业园。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
光明	06:31	23:35	66号线	6分52秒	8-10分钟<br>
深理工	06:29	23:32	66号线	6分52秒	8-10分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
光明	06:31	23:35	66号线	6分52秒	8-10分钟<br>
深理工	06:29	23:32	66号线	6分52秒	8-10分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
光明	06:31	00:35	66号线	6分52秒	8-11分钟<br>
深理工	06:29	00:32	66号线	6分52秒	8-11分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
圳美北街（在建）<br><br>
B出入口:<br>
圳美同富裕工业区<br><br>
C出入口:<br>
中山大学深圳校区<br><br>
D出入口:<br>
中山大学深圳校区<br><br>
E出入口:<br>
中山大学深圳校区<br><br>
F出入口:<br>
光明区艾科智能产业园<br><br>
G出入口:<br>
万代恒高新科技园<br><br>
公交换乘信息<br>

</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "liuhaoxianzhixian",
          title: "6号线支线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>